import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { clientThemeV5 as mainTheme } from './themes/ClientTheme'

export const media = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('md')]: { height: '163px' },
  [theme.breakpoints.down('sm')]: { height: '136px' },
  position: 'relative',
  cursor: 'pointer'
}))

export const card = styled(Card)(({ theme }) => ({
  border: 'none',
  position: 'relative',
  boxShadow: '4px 6px 20px rgb(0 0 0 / 10%)',
  borderRadius: 8,
  '& .MuiCardActionArea-focusHighlight': {
    backgroundColor: theme.palette.grey[800]
  },
  [theme.breakpoints.up('md')]: {
    boxSizing: 'border-box'
  }
}))

export const CardText1 = styled(Box)(({ theme }) => ({
  padding: 12,
  paddingBottom: 0,
  [theme.breakpoints.down('xs')]: { padding: 6 }
}))

export const DetailTitle = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    fontSize: '2rem',
    lineHeight: '1.235'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '16px'
  }
}))

export const LabelTitle = styled(Typography)({
  '&:hover': {
    color: `${mainTheme.palette.grey[800]} !important`
  }
})

export const percentage = styled(Box)(({ theme }) => ({
  color: theme.palette.grey[800],
  '&.complete': {
    color: theme.palette.success.main
  }
}))

export const duration = styled(Box)(({ theme }) => ({
  color: theme.palette.grey[400],
  fontSize: '13px',
  fontWeight: 500,
  height: 18,
  [theme.breakpoints.down('xs')]: { fontSize: '12px' }
}))

export const lessons = styled(Box)(({ theme }) => ({
  position: 'relative',
  background: '#F5F6F6',
  marginTop: theme.spacing(4),
  borderRadius: 16,
  boxShadow: 'none',
  '&.active': {
    border: '2px solid',
    borderColor: theme.palette.error.main,
    background: '#FAECF0'
  },
  '&:hover': {
    cursor: 'pointer',
    background: theme.palette.error.light
  },
  '& h6': {
    fontWeight: 500
  },
  '&.block': {
    border: 'none',
    background: theme.palette.grey[100],
    '&:hover': {
      background: theme.palette.grey[100]
    }
  }
}))

export const LessonContent = styled(Box)({
  fontFamily: 'Poppins, sans-serif'
})

export const TextPrimary = styled(Box)({
  color: mainTheme.palette.primary.main
})

export const LessonsMaterial = styled(Box)(({ theme }) => ({
  boxShadow: '0px 8px 25px 0px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacing(4),
  justifyContent: 'space-between',
  flexDirection: 'column',
  padding: theme.spacing(2),
  maxWidth: '200px',
  '& img': {
    borderRadius: theme.spacing(1),
    maxHeight: 'auto',
    width: '100%'
  },
  cursor: 'pointer'
}))

export const CardAction = styled(Box)({
  paddingTop: 8
})

export const VisbilityBlock = styled(Box)({
  paddingTop: 12,
  '& button': {
    marginBottom: '-17px',
    position: 'relative',
    bottom: 11
  }
})

export const LessonView = styled(Box)({
  '& iframe': {
    width: '100% !important',
    border: 'none !important'
  },
  '& p': {
    padding: '0px !important'
  }
})

export const LessonPlay = styled(Box)(({ theme }) => ({
  color: theme.palette.grey[500],
  fontSize: '56px !important',
  '&.live': {
    color: theme.palette.error.main
  },
  '&.new': {
    color: theme.palette.success.main
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '32px !important'
  }
}))
